import React, { useState } from 'react';

const SecurityModal = ({ onSubmit, isOpen }) => {
  const [securityCode, setSecurityCode] = useState('');
  const [error, setError] = useState('');

  // Get security pass from environment variable or use default for testing
  const getSecurityPass = () => {
    return process.env.REACT_APP_SECURITY_PASS || 'hexas123';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!securityCode.trim()) {
      setError('Please enter the security code');
      return;
    }

    // Check if the entered code matches the environment variable
    if (securityCode === getSecurityPass()) {
      // Simple encoding for localStorage storage
      const encodedCode = btoa(securityCode);
      localStorage.setItem('security_pass', encodedCode);
      setError('');
      onSubmit(true);
    } else {
      setError('Invalid security code. Please try again.');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Security Verification
          </h2>
          <p className="text-gray-600">
            Please enter the security code to access the course content.
          </p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="securityCode" className="block text-sm font-medium text-gray-700 mb-2">
              Security Code
            </label>
            <input
              type="password"
              id="securityCode"
              value={securityCode}
              onChange={(e) => setSecurityCode(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter security code"
              autoFocus
            />
          </div>
          
          {error && (
            <div className="text-red-600 text-sm">{error}</div>
          )}
          
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default SecurityModal; 